import Api from "./baseApi";
export default {
  searchProductCategory: ProductCategory => {
    let url = "/api/productCategory?v=1";
    if (ProductCategory.search) url += `&q=${ProductCategory.search}`;
    if (ProductCategory.state > -1) url += `&state=${ProductCategory.state}`;
    if (ProductCategory.startDate)
      url += `&startDate=${ProductCategory.startDate}`;
    if (ProductCategory.endDate) url += `&endDate=${ProductCategory.endDate}`;
    return Api.get(url);
  },
  getProductCategories: () => Api.get("/api/ProductCategory"),
  getProductCategory: id => Api.get(`/api/ProductCategory/${id}`)
};
